export const zohoForm = `<!DOCTYPE html>
<html>
  <head>
    <meta http-equiv="content-type" content="text/html; charset=UTF-8" />
    <style>
      #zohoSupportWebToCase textarea,
      #zohoSupportWebToCase input[type="text"],
      #zohoSupportWebToCase select,
      .wb_common {
        width: 280px;
      }
      #zohoSupportWebToCase td {
        padding: 11px 5px;
      }
      #zohoSupportWebToCase textarea,
      #zohoSupportWebToCase input[type="text"],
      #zohoSupportWebToCase select {
        border: 1px solid #ddd;
        padding: 3px 5px;
        border-radius: 3px;
      }
      #zohoSupportWebToCase select {
        box-sizing: unset;
      }
      #zohoSupportWebToCase .wb_selectDate {
        width: auto;
      }
      #zohoSupportWebToCase input.wb_cusInput {
        width: 108px;
      }
      .wb_FtCon {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 15px;
        padding-left: 10px;
      }
      .wb_logoCon {
        display: flex;
        margin-left: 5px;
      }
      .wb_logo {
        max-width: 16px;
        max-height: 16px;
      }
      .zsFormClass {
        background-color: #ffffff;
      }

      @media screen and (min-width: 500px) {
        .zsFormClass {
          width: 600px;
        }
      }
    </style>
    <style>
      .zsFontClass {
        color: #000000;
        font-family: Arial;
        font-size: 13px;
      }
    </style>
    <style>
      .manfieldbdr {
        border-left: 1px solid #ff6448 !important;
      }
      .hleft {
        text-align: left;
      }
      input[type="file"]::-webkit-file-upload-button {
        cursor: pointer;
      }
      .wtcsepcode {
        margin: 0px 15px;
        color: #aaa;
        float: left;
      }
      .wtccloudattach {
        float: left;
        color: #00a3fe !important;
        cursor: pointer;
        text-decoration: none !important;
      }
      .wtccloudattach:hover {
        text-decoration: none !important;
      }
      .wtcuploadinput {
        cursor: pointer;
        float: left;
        width: 62px;
        margin-top: -20px;
        opacity: 0;
        clear: both;
      }
      .wtcuploadfile {
        float: left;
        color: #00a3fe;
      }
      .filenamecls {
        margin-right: 15px;
        float: left;
        margin-top: 5px;
      }
      .clboth {
        clear: both;
      }
      #zsFileBrowseAttachments {
        clear: both;
        margin: 5px 0px 10px;
      }
      .zsFontClass {
        vertical-align: top;
      }
      #tooltip-zc {
        font: normal 12px Arial, Helvetica, sans-serif;
        line-height: 18px;
        position: absolute;
        padding: 8px;
        margin: 20px 0 0;
        background: #fff;
        border: 1px solid #528dd1;
        -moz-border-radius: 5px;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        color: #eee;
        -webkit-box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.2);
        -moz-box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.2);
        z-index: 10000;
        color: #777;
      }
      .wtcmanfield {
        color: #f00;
        font-size: 16px;
        position: relative;
        top: 2px;
        left: 1px;
      }
      #zsCloudAttachmentIframe {
        width: 100%;
        height: 100%;
        z-index: 99999 !important;
        position: fixed;
        left: 0px;
        top: 0px;
        border-style: none;
        display: none;
        background-color: #fff;
      }
      .wtchelpinfo {
        background-position: -246px -485px;
        width: 15px;
        height: 15px;
        display: inline-block;
        position: relative;
        top: 2px;
        background-image: url("https://css.zohostatic.com/support/6298223/images/zs-mpro.png");
      }
      .zsMaxSizeMessage {
        font-size: 13px;
      }
    </style>
    <script src="https://d17nz991552y2g.cloudfront.net/app/js/jqueryandencoder.ffa5afd5124fbedceea9.js"></script>
    <script>
      function trimBoth(str) {
        return jQuery.trim(str);
      }
      function setAllDependancyFieldsMapping() {
        var mapDependancyLabels = getMapDependenySelectValues(
          jQuery("[id='property(module)']").val(),
          "JSON_MAP_DEP_LABELS"
        );
        if (mapDependancyLabels) {
          for (var i = 0; i < mapDependancyLabels.length; i++) {
            var label = mapDependancyLabels[i];
            var obj = document.forms["zsWebToCase_673308000026258276"][label];
            if (obj) {
              setDependent(obj, true);
            }
          }
        }
      }
      function getMapDependenySelectValues(module, key) {
        var dependencyObj = jQuery.parseJSON(
          jQuery("[id='dependent_field_values_" + module + "']").val()
        );
        if (dependencyObj == undefined) {
          return dependencyObj;
        }
        return dependencyObj[key];
      }
      function setDependent(obj, isload) {
        var name = obj.id || (obj[0] && obj[0].id) || "";
        var module = jQuery("[id='property(module)']").val();
        var val = "";
        var myObject = getMapDependenySelectValues(module, "JSON_VALUES");
        if (myObject != undefined) {
          val = myObject[name];
        }
        var mySelObject = getMapDependenySelectValues(
          module,
          "JSON_SELECT_VALUES"
        );
        if (val != null && val != "" && val != "null" && mySelObject) {
          var fields = val;
          for (var i in fields) {
            if (fields.hasOwnProperty(i)) {
              var isDependent = false;
              var label = i;
              var values = fields[i];
              if (label.indexOf(")") > -1) {
                label = label.replace(/\)/g, "_____");
              }
              if (label.indexOf("(") > -1) {
                label = label.replace(/\(/g, "____");
              }
              if (label.indexOf(".") > -1) {
                label = label.replace(/\./g, "___");
              }
              var depObj =
                document.forms["zsWebToCase_673308000026258276"][label];
              if (depObj && depObj.options) {
                var mapValues = "";
                var selected_val = depObj.value;
                var depLen = depObj.options.length - 1;
                for (var n = depLen; n >= 0; n--) {
                  if (depObj.options[n].selected) {
                    if (mapValues == "") {
                      mapValues = depObj.options[n].value;
                    } else {
                      mapValues = mapValues + ";;;" + depObj.options[n].value;
                    }
                  }
                }
                depObj.value = "";
                var selectValues = mySelObject[label];
                for (var k in values) {
                  var rat = k;
                  if (rat == "-None-") {
                    rat = "";
                  }
                  var parentValues = mySelObject[name];
                  if (rat == trimBoth(obj.value)) {
                    isDependent = true;
                    depObj.length = 0;
                    var depvalues = values[k];
                    var depLen = depvalues.length - 1;
                    for (var j = 0; j <= depLen; j++) {
                      var optionElement = document.createElement("OPTION");
                      var displayValue = depvalues[j];
                      var actualValue = displayValue;
                      if (actualValue == "-None-") {
                        optionElement.value = "";
                        displayValue = "-None-";
                      } else {
                        optionElement.value = actualValue;
                      }
                      optionElement.text = displayValue;
                      if (mapValues != undefined) {
                        var mapValue = mapValues.split(";;;");
                        var len = mapValue.length;
                        for (var p = 0; p < len; p++) {
                          if (actualValue == mapValue[p]) {
                            optionElement.selected = true;
                          }
                        }
                      }
                      depObj.options.add(optionElement);
                    }
                  }
                }
                if (!isDependent) {
                  depObj.length = 0;
                  var len = selectValues.length;
                  for (var j = 0; j < len; j++) {
                    var actualValue = selectValues[j];
                    var optionElement = document.createElement("OPTION");
                    if (actualValue == "-None-") {
                      optionElement.value = "";
                    } else {
                      optionElement.value = selectValues[j];
                    }
                    optionElement.text = selectValues[j];
                    depObj.options.add(optionElement);
                  }
                  depObj.value = selected_val;
                }
                if (!isload) {
                  setDependent(depObj, false);
                }
                var jdepObj = jQuery(depObj);
                if (jdepObj.hasClass("select2-offscreen")) {
                  jdepObj.select2("val", jdepObj.val());
                }
              }
            }
          }
        }
      }
      var zctt = (function () {
        var tt,
          mw = 400,
          top = 10,
          left = 0,
          doctt = document;
        var ieb = doctt.all ? true : false;
        return {
          showtt: function (cont, wid) {
            if (tt == null) {
              tt = doctt.createElement("div");
              tt.setAttribute("id", "tooltip-zc");
              doctt.body.appendChild(tt);
              doctt.onmousemove = this.setpos;
              doctt.onclick = this.hidett;
            }
            tt.style.display = "block";
            tt.innerHTML = cont;
            tt.style.width = wid ? wid + "px" : "auto";
            if (!wid && ieb) {
              tt.style.width = tt.offsetWidth;
            }
            if (tt.offsetWidth > mw) {
              tt.style.width = mw + "px";
            }
            h = parseInt(tt.offsetHeight) + top;
            w = parseInt(tt.offsetWidth) + left;
          },
          hidett: function () {
            tt.style.display = "none";
          },
          setpos: function (e) {
            var u = ieb ? event.clientY + doctt.body.scrollTop : e.pageY;
            var l = ieb ? event.clientX + doctt.body.scrollLeft : e.pageX;
            var cw = doctt.body.clientWidth;
            var ch = doctt.body.clientHeight;
            if (l < 0) {
              tt.style.left = left + "px";
              tt.style.right = "";
            } else if (l + w + left > cw) {
              tt.style.left = "";
              tt.style.right = cw - l + left + "px";
            } else {
              tt.style.right = "";
              tt.style.left = l + left + "px";
            }
            if (u < 0) {
              tt.style.top = top + "px";
              tt.style.bottom = "";
            } else if (u + h + left > ch) {
              tt.style.top = "";
              tt.style.bottom = ch - u + top + "px";
            } else {
              tt.style.bottom = "";
              tt.style.top = u + top + "px";
            }
          },
        };
      })();
      var zsWebFormMandatoryFields = new Array(
        "Contact Name",
        "Email",
        "Subject"
      );
      var zsFieldsDisplayLabelArray = new Array(
        "Last Name",
        "Email",
        "Subject"
      );
      function zsValidateMandatoryFields() {
        var name = "";
        var email = "";
        var isError = 0;
        for (var index = 0; index < zsWebFormMandatoryFields.length; index++) {
          isError = 0;
          var fieldObject =
            document.forms["zsWebToCase_673308000026258276"][
              zsWebFormMandatoryFields[index]
            ];
          if (fieldObject) {
            if (fieldObject.value.replace(/^\s+|\s+$/g, "").length == 0) {
              alert(zsFieldsDisplayLabelArray[index] + " cannot be empty ");
              fieldObject.focus();
              isError = 1;
              return false;
            } else {
              if (fieldObject.name == "Email") {
                if (
                  !fieldObject.value.match(
                    /^([\w_][\w\-_.+\'&]*)@(?=.{4,256}$)(([\w]+)([\-_]*[\w])*[\.])+[a-zA-Z]{2,22}$/
                  )
                ) {
                  isError = 1;
                  alert("Enter a valid email-Id");
                  fieldObject.focus();
                  return false;
                }
              }
            }
            if (fieldObject.nodeName == "SELECT") {
              if (
                fieldObject.options[fieldObject.selectedIndex].value == "-None-"
              ) {
                alert(zsFieldsDisplayLabelArray[index] + " cannot be none");
                fieldObject.focus();
                isError = 1;
                return false;
              }
            }
            if (fieldObject.type == "checkbox") {
              if (fieldObject.checked == false) {
                alert("Please accept " + zsFieldsDisplayLabelArray[index]);
                fieldObject.focus();
                isError = 1;
                return false;
              }
            }
          }
        }
        if (isError == 0) {
          document
            .getElementById("zsSubmitButton_673308000026258276")
            .setAttribute("disabled", "disabled");
        }
      }
      document.addEventListener("readystatechange", function () {
        if (document.readyState === "complete" && window.zsRegenerateCaptcha) {
          zsRegenerateCaptcha();
        }
        setAllDependancyFieldsMapping();
        document
          .getElementById("zsSubmitButton_673308000026258276")
          .removeAttribute("disabled");
      });
      function zsResetWebForm(webFormId) {
        document.forms["zsWebToCase_" + webFormId].reset();
        document
          .getElementById("zsSubmitButton_673308000026258276")
          .removeAttribute("disabled");
        setAllDependancyFieldsMapping();
      }
    </script>
  </head>
  <div id="zohoSupportWebToCase" align="center">
    <form
      name="zsWebToCase_673308000026258276"
      id="zsWebToCase_673308000026258276"
      action="https://desk.zoho.com/support/WebToCase"
      method="POST"
      onSubmit="return zsValidateMandatoryFields()"
      enctype="multipart/form-data"
    >
      <input
        type="hidden"
        name="xnQsjsdp"
        value="edbsneadd6c540728520829bc5026f856cd67"
      />
      <input
        type="hidden"
        name="xmIwtLD"
        value="edbsnb58c3196cb286112522bdbfd5bb76b663b7541aae6bf0b32f5b8324228705067"
      />
      <input type="hidden" name="xJdfEaS" value="" />
      <input type="hidden" name="actionType" value="Q2FzZXM=" />
      <input type="hidden" id="property(module)" value="Cases" />
      <input
        type="hidden"
        id="dependent_field_values_Cases"
        value='&#x7b;"JSON_VALUES"&#x3a;&#x7b;"Category"&#x3a;&#x7b;"Classification"&#x3a;&#x7b;"App"&#x3a;&#x5b;"Non&#x20;-&#x20;receipt&#x20;of&#x20;OTP&#x20;for&#x20;email&#x20;verification","Unable&#x20;to&#x20;complete&#x20;KYC&#x20;for&#x20;loan&#x20;application"&#x5d;,"Bank&#x20;Transfer"&#x3a;&#x5b;"Confirm&#x20;transfer&#x20;status","Request&#x20;to&#x20;repush&#x20;transaction","Bank&#x20;Transfer&#x20;Stand&#x2f;Dangler&#x2f;Sticker&#x20;Request"&#x5d;,"Settlement"&#x3a;&#x5b;"Pending&#x20;settlement","Dispute&#x2f;Chargeback","Change&#x20;of&#x20;Settlement&#x20;account"&#x5d;,"Loan"&#x3a;&#x5b;"Unable&#x20;to&#x20;submit&#x20;Loan&#x20;Application","How&#x20;can&#x20;I&#x20;apply&#x20;for&#x20;Loan&#x3f;"&#x5d;,"POS"&#x3a;&#x5b;"POS&#x20;deployment","Terminal&#x20;Remap","Paper&#x20;Roll&#x20;Request","Slip&#x20;Header&#x20;change","POS&#x20;not&#x20;booting","Data&#x20;Top&#x20;Up","Time&#x20;Out&#x20;error","Transaction&#x20;not&#x20;showing&#x20;on&#x20;the&#x20;dashboard","Read&#x20;Card&#x20;Error","System&#x20;Error","Unable&#x20;to&#x20;login","Faulty&#x20;POS","Faulty&#x20;Battery&#x2f;Printer&#x2f;Charger","Faint&#x20;receipt","Unable&#x20;to&#x20;print&#x20;receipts","Sim&#x20;Card&#x20;Change","Declined&#x20;Transaction","How&#x20;can&#x20;I&#x20;get&#x20;a&#x20;POS&#x20;terminal&#x3f;","How&#x20;much&#x20;is&#x20;it&#x20;to&#x20;get&#x20;Traction&#x20;POS&#x3f;","How&#x20;to&#x20;create&#x20;fixed&#x20;account&#x3f;","Enquiry&#x20;on&#x20;how&#x20;to&#x20;change&#x20;password","Enquiry&#x20;on&#x20;transfer&#x20;limit&#x20;and&#x20;transaction&#x20;Charge"&#x5d;,"Wallet"&#x3a;&#x5b;"Enquiry&#x20;on&#x20;how&#x20;to&#x20;change&#x20;password","Enquiry&#x20;on&#x20;transfer&#x20;limit&#x20;and&#x20;transaction&#x20;Charge","Unable&#x20;to&#x20;transfer&#x20;out&#x20;of&#x20;wallet","Unable&#x20;to&#x20;view&#x20;transaction&#x20;history","Error&#x20;in&#x20;wallet&#x20;error&#x20;message","How&#x20;to&#x20;create&#x20;wallet"&#x5d;,"Reports"&#x3a;&#x5b;"Transaction&#x20;Report","Wallet&#x20;report","Settlement&#x20;Report","Loan&#x20;repayment&#x20;report","Settlement&#x20;Receipt&#x2f;Session&#x20;ID&#x20;Request"&#x5d;,"Traction"&#x3a;&#x5b;"Tell&#x20;us&#x20;about&#x20;Traction"&#x5d;&#x7d;&#x7d;&#x7d;,"JSON_SELECT_VALUES"&#x3a;&#x7b;"Category"&#x3a;&#x5b;"Reports","POS","Wallet","Traction","App","Settlement","Loan","Bank&#x20;Transfer"&#x5d;,"Classification"&#x3a;&#x5b;"Transaction&#x20;Report","Wallet&#x20;report","Settlement&#x20;Report","Loan&#x20;repayment&#x20;report","Settlement&#x20;Receipt&#x2f;Session&#x20;ID&#x20;Request","POS&#x20;deployment","Terminal&#x20;Remap","Paper&#x20;Roll&#x20;Request","Slip&#x20;Header&#x20;change","POS&#x20;not&#x20;booting","Data&#x20;Top&#x20;Up","Time&#x20;Out&#x20;error","Transaction&#x20;not&#x20;showing&#x20;on&#x20;the&#x20;dashboard","Read&#x20;Card&#x20;Error","System&#x20;Error","Unable&#x20;to&#x20;login","Faulty&#x20;POS","Faulty&#x20;Battery&#x2f;Printer&#x2f;Charger","Faint&#x20;receipt","Unable&#x20;to&#x20;print&#x20;receipts","Sim&#x20;Card&#x20;Change","Declined&#x20;Transaction","How&#x20;can&#x20;I&#x20;get&#x20;a&#x20;POS&#x20;terminal&#x3f;","How&#x20;much&#x20;is&#x20;it&#x20;to&#x20;get&#x20;Traction&#x20;POS&#x3f;","How&#x20;to&#x20;create&#x20;fixed&#x20;account&#x3f;","Enquiry&#x20;on&#x20;how&#x20;to&#x20;change&#x20;password","Enquiry&#x20;on&#x20;transfer&#x20;limit&#x20;and&#x20;transaction&#x20;Charge","Confirm&#x20;transfer&#x20;status","Request&#x20;to&#x20;repush&#x20;transaction","Bank&#x20;Transfer&#x20;Stand&#x2f;Dangler&#x2f;Sticker&#x20;Request","Unable&#x20;to&#x20;transfer&#x20;out&#x20;of&#x20;wallet","Unable&#x20;to&#x20;view&#x20;transaction&#x20;history","Error&#x20;in&#x20;wallet&#x20;error&#x20;message","How&#x20;to&#x20;create&#x20;wallet","Pending&#x20;settlement","Dispute&#x2f;Chargeback","Change&#x20;of&#x20;Settlement&#x20;account","Unable&#x20;to&#x20;submit&#x20;Loan&#x20;Application","How&#x20;can&#x20;I&#x20;apply&#x20;for&#x20;Loan&#x3f;","Non&#x20;-&#x20;receipt&#x20;of&#x20;OTP&#x20;for&#x20;email&#x20;verification","Unable&#x20;to&#x20;complete&#x20;KYC&#x20;for&#x20;loan&#x20;application","Tell&#x20;us&#x20;about&#x20;Traction"&#x5d;&#x7d;,"JSON_MAP_DEP_LABELS"&#x3a;&#x5b;"Category"&#x5d;&#x7d;'
      />
      <input
        type="hidden"
        name="returnURL"
        value="https&#x3a;&#x2f;&#x2f;web.tractionapps.co&#x2f;&#x23;&#x2f;dashboard"
      />
      <table border="0" cellspacing="0" class="zsFormClass">
        <tr>
          <td colspan="2" class="zsFontClass">
            <strong>Traction Support Form</strong>
          </td>
        </tr>
        <br />
        <tr>
          <td nowrap class="zsFontClass" width="25%" align="left">
            First Name&nbsp;&nbsp;
          </td>
          <td align="left" width="75%">
            <input type="text" maxlength="120" name="First Name" value="" />
          </td>
        </tr>
        <tr>
          <td nowrap class="zsFontClass" width="25%" align="left">
            Last Name&nbsp;&nbsp;
          </td>
          <td align="left" width="75%">
            <input
              type="text"
              maxlength="120"
              name="Contact Name"
              class="manfieldbdr"
            />
          </td>
        </tr>
        <tr>
          <td nowrap class="zsFontClass" width="25%" align="left">
            Email&nbsp;&nbsp;
          </td>
          <td align="left" width="75%">
            <input
              type="text"
              maxlength="120"
              name="Email"
              value=""
              class="manfieldbdr"
            />
          </td>
        </tr>
        <tr>
          <td nowrap class="zsFontClass" width="25%" align="left">
            Issue Type &nbsp;&nbsp;
          </td>
          <td align="left" width="75%">
            <select
              name="Category"
              value=""
              onchange="setDependent(this, false)"
              id="Category"
            >
              <option value="Reports">Reports</option>
              <option value="POS">POS</option>
              <option value="Wallet">Wallet</option>
              <option value="Traction">Traction</option>
              <option value="App">App</option>
              <option value="Settlement">Settlement</option>
              <option value="Loan">Loan</option>
              <option value="Bank Transfer">Bank Transfer</option>
            </select>
          </td>
        </tr>
        <tr>
          <td nowrap class="zsFontClass" width="25%" align="left">
            Issue Sub-type &nbsp;&nbsp;
          </td>
          <td align="left" width="75%">
            <select
              name="Classification"
              value=""
              onchange="setDependent(this, false)"
              id="Classification"
            >
              <option value="Transaction Report">Transaction Report</option>
              <option value="Wallet report">Wallet report</option>
              <option value="Settlement Report">Settlement Report</option>
              <option value="Loan repayment report">
                Loan repayment report
              </option>
              <option value="Settlement Receipt/Session ID Request">
                Settlement Receipt/Session ID Request
              </option>
              <option value="POS deployment">POS deployment</option>
              <option value="Terminal Remap">Terminal Remap</option>
              <option value="Paper Roll Request">Paper Roll Request</option>
              <option value="Slip Header change">Slip Header change</option>
              <option value="POS not booting">POS not booting</option>
              <option value="Data Top Up">Data Top Up</option>
              <option value="Time Out error">Time Out error</option>
              <option value="Transaction not showing on the dashboard">
                Transaction not showing on the dashboard
              </option>
              <option value="Read Card Error">Read Card Error</option>
              <option value="System Error">System Error</option>
              <option value="Unable to login">Unable to login</option>
              <option value="Faulty POS">Faulty POS</option>
              <option value="Faulty Battery/Printer/Charger">
                Faulty Battery/Printer/Charger
              </option>
              <option value="Faint receipt">Faint receipt</option>
              <option value="Unable to print receipts">
                Unable to print receipts
              </option>
              <option value="Sim Card Change">Sim Card Change</option>
              <option value="Declined Transaction">Declined Transaction</option>
              <option value="How can I get a POS terminal?">
                How can I get a POS terminal?
              </option>
              <option value="How much is it to get Traction POS?">
                How much is it to get Traction POS?
              </option>
              <option value="How to create fixed account?">
                How to create fixed account?
              </option>
              <option value="Enquiry on how to change password">
                Enquiry on how to change password
              </option>
              <option value="Enquiry on transfer limit and transaction Charge">
                Enquiry on transfer limit and transaction Charge
              </option>
              <option value="Confirm transfer status">
                Confirm transfer status
              </option>
              <option value="Request to repush transaction">
                Request to repush transaction
              </option>
              <option value="Bank Transfer Stand/Dangler/Sticker Request">
                Bank Transfer Stand/Dangler/Sticker Request
              </option>
              <option value="Unable to transfer out of wallet">
                Unable to transfer out of wallet
              </option>
              <option value="Unable to view transaction history">
                Unable to view transaction history
              </option>
              <option value="Error in wallet error message">
                Error in wallet error message
              </option>
              <option value="How to create wallet">How to create wallet</option>
              <option value="Pending settlement">Pending settlement</option>
              <option value="Dispute/Chargeback">Dispute/Chargeback</option>
              <option value="Change of Settlement account">
                Change of Settlement account
              </option>
              <option value="Unable to submit Loan Application">
                Unable to submit Loan Application
              </option>
              <option value="How can I apply for Loan?">
                How can I apply for Loan?
              </option>
              <option value="Non - receipt of OTP for email verification">
                Non - receipt of OTP for email verification
              </option>
              <option value="Unable to complete KYC for loan application">
                Unable to complete KYC for loan application
              </option>
              <option value="Tell us about Traction">
                Tell us about Traction
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <td nowrap class="zsFontClass" width="25%" align="left">
            Subject&nbsp;&nbsp;
          </td>
          <td align="left" width="75%">
            <input
              type="text"
              maxlength="255"
              name="Subject"
              value=""
              class="manfieldbdr"
            />
          </td>
        </tr>
        <tr>
          <td nowrap class="zsFontClass" width="25%" align="left">
            Description &nbsp;&nbsp;
          </td>
          <td align="left" width="75%">
            <textarea
              name="Description"
              maxlength="3000"
              width="250"
              height="250"
            ></textarea>
          </td>
        </tr>
        <tr>
          <td
            style="padding: 11px 5px 0px 5px"
            colspan="2"
            align="center"
            width="25%"
          >
            <input
              type="submit"
              id="zsSubmitButton_673308000026258276"
              class="zsFontClass"
              value="Submit"
            />
            &nbsp; &nbsp;
            <input
              type="button"
              class="zsFontClass"
              value="Reset"
              onclick="zsResetWebForm('673308000026258276')"
            />
          </td>
        </tr>
        <tr>
          <td width="25%" align="left"></td>
          <td style="padding: 0px 5px" align="left" width="75%">
            <div class="wb_FtCon wb_common">
              <span>powered by </span
              ><a
                target="_blank"
                rel="noopener noreferrer"
                href="https://zoho.com/desk"
                class="wb_logoCon"
                ><img
                  class="wb_logo"
                  src="https://d1ydxa2xvtn0b5.cloudfront.net/app/images/portalLogo.de847024ebc0131731a3.png"
              /></a>
            </div>
          </td>
        </tr>
      </table>
    </form>
  </div>
</html>
`;